<div class="h-full bg-white overflow-hidden relative">
  <div class="h-full overflow-y-auto">

    <!-- Page Header -->
    <div class="flex items-center pt-5 px-7 gap-2">
      <span class="material-icons text-[var(--primary-dark)] text-[20px]">task</span>
      <span class="text-[16px] font-bold text-[var(--base-text-dark)]">Lab Manager</span>
    </div>

    <!-- Toolbar -->
    <div class="flex items-center gap-2.5 py-3.5 px-7 flex-wrap mt-4">
      <!-- Agent Dropdown -->
      <mat-form-field *ngIf="isRepresentative" class="w-[370px]" appearance="outline">
        <mat-label>Select Agent</mat-label>
        <mat-select [(ngModel)]="selectedRepresentative">
          <mat-option *ngFor="let agent of representatives" [value]="agent" (click)="setSelectedLabAgent(agent)">
            {{agent.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- New Submission Button -->
      <button (click)="addNewLabSubmission()"
        class="py-2 px-3.5 bg-[var(--primary-dark)] rounded-lg text-xs font-semibold text-white cursor-pointer flex items-center gap-1.5 hover:opacity-90 transition-all">
        <span class="material-icons text-[16px]">add</span> New Submission
      </button>

      <!-- Search -->
      <div class="relative">
        <span class="material-icons absolute left-2.5 top-1/2 -translate-y-1/2 text-[18px] text-[var(--tertiary-text)]">search</span>
        <input type="text" placeholder="Search submissions..." [(ngModel)]="searchText" (ngModelChange)="searchLabSubmissions()"
          class="py-2 pl-9 pr-3 border-[1.5px] border-[var(--app-border)] rounded-lg text-[13px] w-[200px] outline-none transition-colors bg-[var(--app-base)] focus:border-[var(--primary-dark)] text-[var(--base-text-alt-dark)]">
      </div>

      <!-- Clear Filters -->
      <button *ngIf="isFilterBtnVisible" (click)="resetFilter()"
        class="py-2 px-3.5 border-[1.5px] border-[var(--app-border)] rounded-lg text-xs font-semibold bg-white text-[var(--base-text-alt-dark)] cursor-pointer flex items-center gap-1.5 hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] transition-all">
        <span class="material-icons text-[16px]">filter_alt_off</span> Clear Filters
      </button>

      <div class="flex-1"></div>

      <!-- Filter Button -->
      <button (click)="openFilterDialog()"
        class="mr-6 py-2 px-3.5 border-[1.5px] border-[var(--app-border)] rounded-lg text-xs font-semibold bg-white text-[var(--base-text-alt-dark)] cursor-pointer flex items-center gap-1.5 hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] transition-all">
        <span class="material-icons text-[16px]">tune</span> Filtering
      </button>
    </div>

    <!-- Table -->
    <div class="px-7 overflow-y-auto" [ngStyle]="{'height': tableHeight}">
      <table mat-table [dataSource]="dataSource.data" class="w-full border-collapse">

        <ng-container matColumnDef="labSubmission">
          <th mat-header-cell *matHeaderCellDef class="!py-3 !px-3.5 !text-[11px] !font-bold !uppercase !tracking-wider !text-[var(--tertiary-text)] !bg-[var(--app-base)] !text-left !whitespace-nowrap !border-b !border-[var(--app-base)]">Lab Reference</th>
          <td mat-cell *matCellDef="let element" class="!py-2 !px-3.5 !text-[13px] !font-medium !text-[var(--base-text-alt-dark)] !border-b !border-[var(--app-base)]">{{element?.submissionId ?? '-'}}</td>
        </ng-container>

        <ng-container matColumnDef="dateCreated">
          <th mat-header-cell *matHeaderCellDef class="!py-3 !px-3.5 !text-[11px] !font-bold !uppercase !tracking-wider !text-[var(--tertiary-text)] !bg-[var(--app-base)] !text-left !whitespace-nowrap !border-b !border-[var(--app-base)]">Date Created</th>
          <td mat-cell *matCellDef="let element" class="!py-2 !px-3.5 !text-[13px] !font-normal !text-[var(--tertiary-text)] !border-b !border-[var(--app-base)]">{{element?.creationDate ? (element.creationDate | date:'yyyy-MM-dd') : '-'}}</td>
        </ng-container>

        <ng-container matColumnDef="client">
          <th mat-header-cell *matHeaderCellDef class="!py-3 !px-3.5 !text-[11px] !font-bold !uppercase !tracking-wider !text-[var(--tertiary-text)] !bg-[var(--app-base)] !text-left !whitespace-nowrap !border-b !border-[var(--app-base)]">Client</th>
          <td mat-cell *matCellDef="let element" class="!py-2 !px-3.5 !text-[13px] !font-medium !text-[var(--base-text-alt-dark)] !border-b !border-[var(--app-base)]">{{element?.otcCustomerDetailName ?? '-'}}</td>
        </ng-container>

        <ng-container matColumnDef="createdBy">
          <th mat-header-cell *matHeaderCellDef class="!py-3 !px-3.5 !text-[11px] !font-bold !uppercase !tracking-wider !text-[var(--tertiary-text)] !bg-[var(--app-base)] !text-left !whitespace-nowrap !border-b !border-[var(--app-base)]">Created By</th>
          <td mat-cell *matCellDef="let element" class="!py-2 !px-3.5 !text-[13px] !font-medium !text-[var(--base-text-alt-dark)] !border-b !border-[var(--app-base)]">{{element?.creationUserName && element?.creationUserSurname ? (element.creationUserName + ' ' + element.creationUserSurname) : '-'}}</td>
        </ng-container>

        <ng-container matColumnDef="noOfSamples">
          <th mat-header-cell *matHeaderCellDef class="!py-3 !px-3.5 !text-[11px] !font-bold !uppercase !tracking-wider !text-[var(--tertiary-text)] !bg-[var(--app-base)] !text-left !whitespace-nowrap !border-b !border-[var(--app-base)]">Samples</th>
          <td mat-cell *matCellDef="let element" class="!py-2 !px-3.5 !text-[13px] !font-normal !text-[var(--tertiary-text)] !border-b !border-[var(--app-base)]">{{element?.sampleCount ?? '-'}}</td>
        </ng-container>

        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef class="!py-3 !px-3.5 !text-[11px] !font-bold !uppercase !tracking-wider !text-[var(--tertiary-text)] !bg-[var(--app-base)] !text-left !whitespace-nowrap !border-b !border-[var(--app-base)]">Type</th>
          <td mat-cell *matCellDef="let element" class="!py-2 !px-3.5 !text-[13px] !font-normal !text-[var(--tertiary-text)] !border-b !border-[var(--app-base)]">{{element?.labManTypesDescription ?? '-'}}</td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef class="!py-3 !px-3.5 !text-[11px] !font-bold !uppercase !tracking-wider !text-[var(--tertiary-text)] !bg-[var(--app-base)] !text-left !whitespace-nowrap !border-b !border-[var(--app-base)]">Status</th>
          <td mat-cell *matCellDef="let element" class="!py-2 !px-3.5 !text-[13px] !font-bold !border-b !border-[var(--app-base)]"
              [ngClass]="{'!text-[#C8C8D2]': element?.labManStatusDescription === 'Draft',
                          '!text-[red]': element?.labManStatusDescription === 'Results Rejected',
                          '!text-[#00B47D]': element?.labManStatusDescription === 'Completed' || element?.labManStatusDescription === 'Results Approved',
                          '!text-[#63B6E6]': element?.labManStatusDescription !== 'Completed' && element?.labManStatusDescription !== 'Draft' && element.labManStatusDescription !== 'Results Approved' && element.labManStatusDescription !== 'Results Rejected'}">
            {{element?.labManStatusDescription ?? '-'}}
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="!py-3 !px-3.5 !bg-[var(--app-base)] !border-b !border-[var(--app-base)]"></th>
          <td mat-cell *matCellDef="let element" class="!py-2 !px-3.5 !border-b !border-[var(--app-base)]">
            <span class="material-icons text-[18px] text-[var(--tertiary-text)] cursor-pointer hover:text-[var(--primary-dark)]" (click)="routeToLabSubmissionDetails(element.id)">chevron_right</span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns" style="height: auto; min-height: unset"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"
          class="cursor-pointer transition-colors !h-auto"
          style="height: auto; min-height: unset"
          (click)="routeToLabSubmissionDetails(row.id)"></tr>
      </table>

      <div *ngIf="noItemsFound" class="flex items-center justify-center h-[200px] text-[var(--tertiary-text)] text-[13px]">
        Sorry! No items found within the selected filter range.
      </div>
    </div>

    <!-- Paginator -->
    <div class="flex items-center justify-end py-3.5 px-7 gap-4 border-t border-[var(--app-base)]">
      <span class="text-[12px] text-[var(--tertiary-text)] font-medium">Items per page:</span>
      <div class="relative" #pageSizeDropdown>
        <div (click)="showPageSizeMenu = !showPageSizeMenu; $event.stopPropagation()"
          class="py-2 px-3.5 border-[1.5px] border-[var(--app-border)] rounded-lg text-xs font-semibold bg-white text-[var(--base-text-alt-dark)] cursor-pointer flex items-center gap-1.5 hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] transition-all">
          <span>{{pageSize}}</span>
          <span class="material-icons text-[16px]">expand_more</span>
        </div>
        <div *ngIf="showPageSizeMenu"
          class="absolute bottom-[calc(100%+4px)] left-0 min-w-[80px] bg-white rounded-[10px] shadow-[0_8px_24px_rgba(0,0,0,0.12)] border border-[var(--app-base)] py-1 z-[100]">
          <div *ngFor="let size of [5, 10, 25, 100]"
            (click)="onPageSizeChange(size)"
            class="py-2 px-3.5 text-[13px] font-medium text-[var(--base-text-alt-dark)] cursor-pointer transition-colors hover:bg-[var(--app-base)]"
            [class.font-semibold]="size === pageSize">
            {{size}}
          </div>
        </div>
      </div>
      <span class="text-[13px] text-[var(--base-text-alt-dark)] font-medium">{{currentPage * pageSize + 1}} – {{min((currentPage + 1) * pageSize, totalElements)}} of {{totalElements}}</span>
      <div class="flex gap-1">
        <button (click)="goToPage(0)" [disabled]="currentPage === 0"
          class="w-8 h-8 border-[1.5px] border-[var(--app-border)] rounded-lg flex items-center justify-center cursor-pointer bg-white text-[var(--base-text-alt-dark)] hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] disabled:opacity-30 disabled:cursor-default disabled:hover:border-[var(--app-border)] disabled:hover:bg-white disabled:hover:text-[var(--base-text-alt-dark)] transition-all">
          <span class="material-icons text-[16px]">first_page</span>
        </button>
        <button (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 0"
          class="w-8 h-8 border-[1.5px] border-[var(--app-border)] rounded-lg flex items-center justify-center cursor-pointer bg-white text-[var(--base-text-alt-dark)] hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] disabled:opacity-30 disabled:cursor-default disabled:hover:border-[var(--app-border)] disabled:hover:bg-white disabled:hover:text-[var(--base-text-alt-dark)] transition-all">
          <span class="material-icons text-[16px]">chevron_left</span>
        </button>
        <button (click)="goToPage(currentPage + 1)" [disabled]="(currentPage + 1) * pageSize >= totalElements"
          class="w-8 h-8 border-[1.5px] border-[var(--app-border)] rounded-lg flex items-center justify-center cursor-pointer bg-white text-[var(--base-text-alt-dark)] hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] disabled:opacity-30 disabled:cursor-default disabled:hover:border-[var(--app-border)] disabled:hover:bg-white disabled:hover:text-[var(--base-text-alt-dark)] transition-all">
          <span class="material-icons text-[16px]">chevron_right</span>
        </button>
        <button (click)="goToPage(lastPage)" [disabled]="(currentPage + 1) * pageSize >= totalElements"
          class="w-8 h-8 border-[1.5px] border-[var(--app-border)] rounded-lg flex items-center justify-center cursor-pointer bg-white text-[var(--base-text-alt-dark)] hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] disabled:opacity-30 disabled:cursor-default disabled:hover:border-[var(--app-border)] disabled:hover:bg-white disabled:hover:text-[var(--base-text-alt-dark)] transition-all">
          <span class="material-icons text-[16px]">last_page</span>
        </button>
      </div>
    </div>
  </div>
</div>
